export const ECODE_GENERATION_START = "ECODE_GENERATION_START";
export const ECODE_GENERATION_SUCCESS = "ECODE_GENERATION_SUCCESS";
export const ECODE_GENERATION_FAILURE = "ECODE_GENERATION_FAILURE";
export const ECODE_USER_DELETE_START = "ECODE_USER_DELETE_START";
export const ECODE_USER_DELETE_SUCCESS = "ECODE_USER_DELETE_SUCCESS";
export const ECODE_USER_DELETE_FAILURE = "ECODE_USER_DELETE_FAILURE";
export const LOAD_ALL_ECODES= "LOAD_ALL_ECODES";